import ICompanyInformations from './ICompanyInformationsService'
import {AxiosResponse} from 'axios'
import {
    AddContactPersonFormValues,
    AddressDataListItem,
    EditContactPerson,
    SupplierTypeInputModel,
} from './interfaces'
import {ENDPOINT} from "@apps/Shared/Services/Axios/Api";
import {clearServerMessage, renderServerMessage} from "@apps/Shared/Utils/ServerMessage";
import i18n from "@apps/Shared/translation/i18n";
import {Client} from "@apps/Shared/Services/Axios";

class CompanyInformationsService implements ICompanyInformations {
    async GetSupplierTypes() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.SupplierTypes()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetCompanyInfo() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.CompanyInfo()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }
        return res
    }

    async GetCompanyListItem(companyId: string) {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.CompanyDetails()}`, {}, {
                headers: {
                    'x-pm-companyid': companyId,
                },
            });
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetAddresses() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.Addresses()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }
        return res
    }

    async GetContactPersons() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.ContactPersons()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetAgreements() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.Agreements()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async DeleteContactPerson(id: string) {
        let res: AxiosResponse;

        try {
            res = await Client('delete', `${ENDPOINT.CompanyInformations.DeleteContactPerson(id)}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async EditAddress(values: AddressDataListItem) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.CompanyInformations.Address()}`, values);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async EditSupplierTypes(values: SupplierTypeInputModel) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.CompanyInformations.SupplierTypesPost()}`, values);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async DeleteAddress(values: AddressDataListItem) {
        let res: AxiosResponse;

        try {
            res = await Client('delete', `${ENDPOINT.CompanyInformations.Address()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async Users() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.Users()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }
        return res;
    }

    async ContactTypes() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.ContactTypes()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async AddContactPerson(values: AddContactPersonFormValues) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.CompanyInformations.AddContactPerson()}`, values);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async EditContactPerson(values: EditContactPerson) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.CompanyInformations.EditContactPerson(values.id)}`, values);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetAgreementPdf(id: string, appendixIndex?: number) {
        let res: AxiosResponse;

        try {
            const appendix = typeof appendixIndex === 'number' ? appendixIndex : '';
            res = await Client('get', `${ENDPOINT.CompanyInformations.AgreementPdf(id, appendix)}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetConnectedProducersList() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.AllCustomers()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async SearchCustomersAndSuppliers(nameOrNumber: string, signal?: AbortSignal) {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.CompanyInformations.Search(nameOrNumber)}`, {}, {signal});
            clearServerMessage();
        } catch (error: any) {
            if (error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError') {
                return;
            }
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }
}

export default new CompanyInformationsService()
